export default __webpack_public_path__ + "c1a83cc8ba4b195412abfc4401389227.svg";